module.exports = __webpack_public_path__ + "static/media/bj-14-5-logo.600827dd.png";